import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { classNames, forwardRef } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldInfos } from './FormFieldInfos';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { TextInput } from 'components/form/private/inputs/TextInput';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { Button } from 'components/Button';
import './FormInput.scss';
/**
 * @component FormInput
 * @since 1.0.0
 */
export const FormInput = forwardRef((props) => {
    let { name, type, size, style, picto, badge, clearable, label, tooltip, infos, error, scale, min, max, step, required, optional, disabled, placeholder, autoselect, autocorrect, autocomplete, autocapitalize, prefix, suffix, ref, pattern, onKeyDown } = Object.assign({ type: 'text', size: 'medium', name: '', style: 'normal' }, props);
    const form = useForm();
    const [ident] = useIdent('form-input');
    const [value, setValue] = useValue(name, props.value, props.defaultValue || '');
    const [focused, setFocused] = useState(false);
    /**
     * @function onClear
     * @since 1.0.0
     * @hidden
     */
    function onClear() {
        setValue('');
    }
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useIf(focused, props.onFocus, () => { var _a; return (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, value); });
    useWatch(() => {
        if (props.onChange) {
            props.onChange(value);
        }
    }, [value]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-input', 'form-input--' + size, 'form-input--' + style, 'form-input--' + type, { 'form-input--is-required': required }, { 'form-input--is-optional': optional }, { 'form-input--is-disabled': disabled }, { 'form-input--is-focused': focused }, { 'form-input--has-label': label !== '' }, { 'form-input--has-value': value !== '' }, { 'form-input--has-picto': picto }, { 'form-input--has-badge': badge }, { 'form-input--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-input-field" },
            React.createElement("div", { className: "form-input-field-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-input-label", style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-input-infos", style: style, infos: infos }))),
            React.createElement("div", { className: "form-input-field-body" },
                prefix && React.createElement("div", { className: "form-input-prefix" }, prefix),
                React.createElement(TextInput, { name: name, type: type, ident: ident, value: value, scale: scale, required: required, disabled: disabled, placeholder: placeholder, step: step, min: min, max: max, autoselect: autoselect, autocorrect: autocorrect, autocomplete: autocomplete, autocapitalize: autocapitalize, onBlur: onBlur, onFocus: onFocus, onChange: onChange, ref: ref, pattern: pattern, onKeyDown: onKeyDown }),
                picto && React.createElement(Icon, { className: "form-input-picto", value: picto }),
                value && clearable && (React.createElement(Button, { className: "form-input-clear", style: "picto", picto: "fad circle-xmark", onPress: onClear })),
                badge && React.createElement(Text, { className: "form-input-badge", value: badge }),
                suffix && React.createElement("div", { className: "form-input-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
});
